import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import CancelIcon from "@material-ui/icons/Cancel";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import EditIcon from "@material-ui/icons/Edit";

import { useStyles } from "../../../../../../Components/CSS/TableStyle.css";
import { formatTime } from "../../../../../../Components/FormatTime/FormatTime";

class ExamSubjectBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: this.props.editStatus,
    };
  }

  handleEditStatus = () => {
    this.setState({
      editStatus: true,
    });
  };

  handleCancelEditStatus = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleEditSubject = (index, data) => {
    this.handleEditStatus();
    this.props.handleEditStatus(index, data, () =>
      this.handleCancelEditStatus()
    );
  };

  handleCancel = () => {
    this.props.handleCancelEdit();
    this.handleCancelEditStatus();
  };

  render() {
    const { classes, subject, index, handleDeleteSubject } = this.props;
    return this.state.editStatus ? (
      <TableRow>
        <TableCell align="center" colSpan={7}>
          Change in above form
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Remove"
            arrow
            className={classes.tooltip}
            onClick={this.handleCancel}
          >
            <CancelIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    ) : (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{subject.name}</TableCell>
        <TableCell align="center">{subject.date}</TableCell>
        <TableCell align="center">{formatTime(subject.startTime)}</TableCell>
        <TableCell align="center">{formatTime(subject.endTime)}</TableCell>
        <TableCell align="center">{subject.fullMarks}</TableCell>
        <TableCell align="center">{subject.passMarks}</TableCell>
        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditSubject(index, subject)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Remove"
            arrow
            className={classes.tooltip}
            onClick={() => handleDeleteSubject(index)}
          >
            <RemoveCircleIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(useStyles)(ExamSubjectBody);
